export const endPoints = {
  SIPUNI_CONFIG: '/v1/sipuni-config',
  SIPUNI_CONFIG_AUTH: '/v1/sipuni-config/auth',
  SIPUNI_CONFIG_EMPLOYEE: '/v1/sipuni-config/employee',
  SIPUNI_CONFIG_CALL_HANDLING: '/v1/sipuni-config/call-handling',
  SIPUNI_CONFIG_CONTACT: '/v1/sipuni-config/contact',
  SIPUNI_CONFIG_LOGOUT: '/v1/sipuni-config/logout'
};
